import { gql } from '@apollo/client';

export interface ILibraryCategoryEntertainment {
  name: string;
  sys: { id: string };
}

export const LibraryCategoryEntertainmentFragment = gql`
  fragment LibraryCategoryEntertainment on LibraryCategoryEntertainment {
    name
    sys {
      id
    }
  }
`;
